// The Communications inbox (CU-14zcqntr7dk). It stays off the navigation until
// the switch-over ticket replaces the Inbox with it.
export default [
    {
        // One route for the orders list and an order's conversations, so moving
        // between them patches the same view and the list keeps its scroll and
        // search.
        path: '/comms/:orderId(\\d+)?',
        name: 'CommunicationsInbox',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Communications inbox',
            fillPage: true,
        },
        components: {
            default: () => import('@views/comms/CommunicationsInbox.vue'),
        },
    },
];
